import { require200Status } from "../../utils/response.js";
import { transformAccessToken } from "../../../utils/response.js";
function oauthEndpoints(builder) {
  return {
    login: builder.mutation({
      invalidatesTags: ["self"],
      query: ({ client_id, client_secret, grant_type = "password", account }) => ({
        url: "/oauth/access_token",
        method: "POST",
        body: {
          client_id,
          client_secret,
          grant_type,
          account
        },
        validateStatus: require200Status
      }),
      transformResponse: (response) => {
        return transformAccessToken(response);
      }
    })
  };
}
export {
  oauthEndpoints as default
};
